import React, { useState, useRef, useEffect } from "react";
import "./Bracket.css";
import Square from "./Square/Square";
import Lines from "./Lines/Lines";
import Modal from "./Modal/Modal";
import Round from "./Round/Round";
import Notification from "./Notification/Notification";
import confetti from "canvas-confetti";

function Bracket(props) {
  const [gameData, setGameData] = useState(props.gameData);
  const [displayModal, setDisplayModal] = useState(false);
  const [notificationStatus, setNotificationStatus] = useState(false);
  const [modalData, setModalData] = useState([]);
  const [nextData, setNextData] = useState();
  const [currentRound, setCurrentRound] = useState("First Round");
  const [showShareButton, setShareShareButton] = useState(false);
  const gameOrder = [9,10,11,12,19,20,21,22,13,14,17,18,15,16,31]; //the order of sq's in the gameflow
  const gameMatchupOrder = [[1, 2], [3, 4], [5, 6], [7, 8], [23, 24], [25, 26], [27, 28], [29, 30], [9, 10], [11, 12], [19, 20], [21, 22], [13, 14], [17, 18], [15, 16]]; // needed to use Enter key
  const gameNextOrder = [13, 13, 14, 14, 17, 17, 18, 18, 15, 15, 16, 16, 'center', 'center']; // needed to use Enter key
  const [gameOrderIndex, setGameOrderIndex] = useState(0); //used to indicate proper index of gameOrder. Gets incremented in handleHideModal().
  const activePos = useRef(null);
  const appElm = document.querySelector("#App");
  const bracketElm = document.querySelector("#bracket");

  // MODAL CONTROLS
  let showModal = pos => {
    // console.log("gameORDER SLICE: ",gameOrder.slice(0, gameOrderIndex+1), gameOrderIndex+1)
    if (displayModal === true) {
      if ((pos > 8 && pos < 23) || pos === 31) { // Begins deciding when to allow a click on a square. 
        if ((gameData[modalData[0]] && gameData[modalData[1]]) && gameData[nextData] === undefined) { // If the last two elements are filled, and next is empty, allow click 
          if(gameOrder.slice(0, gameOrderIndex+1).includes(pos)) // check if current sq position is in the range of gameOrder up to gameOrderIndex. If so, it means you should be able to select, otherwise prevent it.
          return (
            <Modal handleHideModal={handleHideModal} position={pos} next={pos} left={gameData[modalData[0]]} right={gameData[modalData[1]]} />
          );
        } else {
          console.log("ERROR: BRACKET REQUIRES VALID MATCHUP"); // Can put notification pop-up here, such as: "tap the green square you dumb f**k"
        }
      }
    } else {
      console.log("ERROR: BRACKET REQUIRES VALID MATCHUP"); // Can put notification pop-up here, such as: "tap the green square you dumb f**k"
      return "";
    }
  };

  let handleClassHighlight = (pos, rapper, origin, next) => {
    let highlight = 'highlight';
    let noHighlight = '';
    //if the position is the first or last 8, skip highlights
    if ((pos > 8 && pos < 23) || pos === 31) {
      //if there is already a rapper assigned to a square, skip highlights
      if (!rapper) {
        //if the next square is undefined and the previous squares are defined highlight the square
        // if (!gameData[next] && (gameData[origin[0]] && gameData[origin[1]])) {
          if (pos == gameOrder[gameOrderIndex]) { //compares position of clicked sq to the gameOrderIndex that should be active. If same, then highlight.
          return highlight;
        }
        return noHighlight;
      }
      return noHighlight;
    }
  }

  let handleSquareClick = (pos, origin, next) => {
    // console.log('HANDLE SQUARE CLICK ORIGIN', origin);
    window.trackEvent(`Click Square ${pos}`);
    if (gameData[31] === undefined) {
      activePos.current = pos;
      setNextData(next)
      setModalData(origin);
      setDisplayModal(true);
    }
  };

  const handleKeyPress = (event) => {
    if (event.isComposing || event.keyCode === 229) {
      return;
    }
    if (event.key.toLowerCase() === 'enter') {
      if (gameOrder[gameOrderIndex]) {
        handleSquareClick(
          gameOrder[gameOrderIndex],
          [gameMatchupOrder[gameOrderIndex][0], gameMatchupOrder[gameOrderIndex][1]],
          gameNextOrder[gameOrderIndex]
        );
      }
    }
  }

  useEffect(()=>{
    document.addEventListener('keydown', handleKeyPress);

    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    }
  });


  let smoothScrollTo = (toX, toY) => {
    // console.log('animate to', toX, toY);
    let element = appElm;
    let duration = 300;

    let startY = element.scrollTop,
      changeY = toY - startY,
      currentTimeY = 0,
      incrementY = 20;
    let startX = element.scrollLeft,
      changeX = toX - startX,
      currentTimeX = 0,
      incrementX = 20;

    let animateScrollY = function () {
      currentTimeY += incrementY;
      let val = Math.easeInOutQuad(currentTimeY, startY, changeY, duration);
      element.scrollTop = val;
      if (currentTimeY < duration) {
        setTimeout(animateScrollY, incrementY);
      }
    };
    animateScrollY();

    let animateScrollX = function () {
      currentTimeX += incrementX;
      let val = Math.easeInOutQuad(currentTimeX, startX, changeX, duration);
      element.scrollLeft = val;
      if (currentTimeX < duration) {
        setTimeout(animateScrollX, incrementX);
      }
    };
    animateScrollX();
  }

  //t = current time
  //b = start value
  //c = change in value
  //d = duration
  Math.easeInOutQuad = function (t, b, c, d) {
    t /= d / 2;
    if (t < 1) return c / 2 * t * t + b;
    t--;
    return -c / 2 * (t * (t - 2) - 1) + b;
  };

  let handleHideModal = (pos, chosen) => {
    const copyState = gameData.slice(); //make a copy of state.
    copyState[pos] = Object.assign({}, chosen) //assign the chosen rapper to the state at the position from props
    setDisplayModal(false); //hide the modal
    setGameData(copyState); //Change state of game data to the copy with the new chosen rapper
    if(pos == gameOrder[gameOrderIndex]){
      setGameOrderIndex(gameOrderIndex + 1) //increment the gameOrderIndex by one to highlight the next available square
    }
    // console.log('POSITION CHOSEN', pos);

    if (bracketElm.offsetWidth > window.innerWidth || bracketElm.offsetHeight > window.innerHeight) {
      if (pos === 9) {
        smoothScrollTo(0, 0);  
      } else if (pos === 10) {
        smoothScrollTo(0, bracketElm.offsetHeight / 2);
      } else if (pos === 11) {
        smoothScrollTo(0, bracketElm.offsetHeight / 2)
      } else if (pos === 12) {
        // move right top
        smoothScrollTo(bracketElm.offsetWidth, 0);
      } else if (pos === 19) {
        smoothScrollTo(bracketElm.offsetWidth, 0);
      } else if (pos === 20) {
        smoothScrollTo(bracketElm.offsetWidth, bracketElm.offsetHeight / 2);
      } else if (pos === 21) {
        smoothScrollTo(bracketElm.offsetWidth, bracketElm.offsetHeight / 2);
      } else if (pos === 22) {
        // go to middle-left top
        smoothScrollTo(bracketElm.offsetWidth / 7, 0);
      } else if (pos === 13) {
        smoothScrollTo(bracketElm.offsetWidth / 7, bracketElm.offsetHeight / 2);
      } else if (pos === 14) {
        // right-middle top
        smoothScrollTo(bracketElm.offsetWidth / 2, 0);
      } else if (pos === 17) {
        smoothScrollTo(bracketElm.offsetWidth / 2, bracketElm.offsetHeight / 2);
      } else if (pos === 18) {
        // center
        smoothScrollTo((bracketElm.offsetWidth / 2) - ((window.innerWidth) - 13), (bracketElm.offsetHeight / 2) - ((window.innerHeight / 2) - 13));
      } else if (pos === 15) {
        // center
        smoothScrollTo(bracketElm.offsetWidth / 2, (bracketElm.offsetHeight / 2) - ((window.innerHeight / 2) - 13));
      } else if (pos === 16) {
        // center 
        smoothScrollTo((bracketElm.offsetWidth / 2) - ((window.innerWidth / 2) - 7), (bracketElm.offsetHeight / 2) - window.innerHeight / 2 + 100);
      }
    }
  };

  const lastSelection = gameData[31]

  useEffect(()=>{
    if(lastSelection){
      props.handleGameDataWinners(gameData)
      props.setGameWinner(lastSelection)
      setShareShareButton(true)
    }
  },[lastSelection, gameData])

  let showNotification = () => {
    // console.log("notification")
    setNotificationStatus(true);
    setTimeout(function(){
      return setNotificationStatus(false)
    },3000)
  }

  // dropCrown is called below in bracket column five, on the submission of the center square click.
  let dropCrown = () => {
    if (gameData[31] !== undefined) {
      createConfetti();
      return (
        <React.Fragment>
          <div className="crown animated bounceInDown" />
        </React.Fragment>
      )
    }
    else {
      return "";
    }
  }

  //Create Confetti is called inside of function dropCrown.
  let createConfetti = () => {
    var ourConfetti = confetti.create(document.getElementById("confetti_canvas"), { resize: true });
    var end1 = Date.now() + (20 * 1000);
    var end2 = Date.now() + (1 * 1000);
    (function frame1() {
      ourConfetti({
        particleCount: 2,
        startVelocity: -10,
        ticks: 400,
        origin: {
          x: Math.random(),
          // since they fall down, start a bit higher than random
          y: Math.random() - 0.2
        },
        colors: ['#369e06']
      });
      ourConfetti({
        particleCount: 2,
        startVelocity: -5,
        ticks: 150,
        origin: {
          x: Math.random(),
          // since they fall down, start a bit higher than random
          y: Math.random() - 0.2
        },
        colors: ['#3CEE04']
      });
      if (Date.now() < end1) {
        requestAnimationFrame(frame1);
      }
    }());
    (function frame2() {
      ourConfetti({
        particleCount: 2,
        angle: 60,
        spread: 55,
        origin: {
          x: 0
        },
        colors: ['#82c96d']
      });
      ourConfetti({
        particleCount: 2,
        angle: 120,
        spread: 55,
        origin: {
          x: 1
        },
        colors: ['#82c96d']
      });
      if (Date.now() < end2) {
        requestAnimationFrame(frame2);
      }
    }());
  }

  // console.log("Game Data: ", gameData);

  useEffect(()=> {
    // console.log("USEEFFECT RUNNING")
    if (!gameData[9] || !gameData[10] || !gameData[11] || !gameData[12] || !gameData[19] || !gameData[20] || !gameData[21] || !gameData[22]) {
      setCurrentRound("First Round");
    }
    if ((gameData[9] && gameData[10] && gameData[11] && gameData[12] && gameData[19] && gameData[20] && gameData[21] && gameData[22])
      && (!gameData[13] || !gameData[14] || !gameData[17] || !gameData[18])) {
        setCurrentRound("Quarter Finals");
    }
    if ((gameData[9] && gameData[10] && gameData[11] && gameData[12] && gameData[19] && gameData[20] && gameData[21] && gameData[22] && gameData[13] && gameData[14] && gameData[17] && gameData[18])
      && (!gameData[15] || !gameData[16])) {
      setCurrentRound("Semi Finals");
    }
    if ((gameData[9] && gameData[10] && gameData[11] && gameData[12] && gameData[19] && gameData[20] && gameData[21] && gameData[22] && gameData[13] && gameData[14] && gameData[17] && gameData[18] && gameData[15] && gameData[16])
      && !gameData[31]) {
        setCurrentRound("Grand Finals");
    }
  },[gameData])
  
  return (
    <React.Fragment>
      <div id="brackets_wrapper">
        <canvas id="confetti_canvas" />
        <div className="bracket_button_restart" onClick={() => {
          props.selectGameMode("start");
          window.trackEvent('Click Restart Button');
        }}>RESTART</div>
        {displayModal && showModal(activePos.current)}
        {showShareButton && 
        (<div className="bracket_button_share animated bounceInUp" onClick={() => {
          if (window.innerWidth <= 850) {
            window.open(`https://partner.complex.com/rap-brackets-share/${gameData[1].id}-${gameData[2].id}-${gameData[3].id}-${gameData[4].id}-${gameData[5].id}-${gameData[6].id}-${gameData[7].id}-${gameData[8].id}-${gameData[9].id}-${gameData[10].id}-${gameData[11].id}-${gameData[12].id}-${gameData[13].id}-${gameData[14].id}-${gameData[15].id}-${gameData[16].id}-${gameData[17].id}-${gameData[18].id}-${gameData[19].id}-${gameData[20].id}-${gameData[21].id}-${gameData[22].id}-${gameData[23].id}-${gameData[24].id}-${gameData[25].id}-${gameData[26].id}-${gameData[27].id}-${gameData[28].id}-${gameData[29].id}-${gameData[30].id}-${gameData[31].id}`);
          } else {
            props.selectGameMode("share");
          }
          window.trackEvent('Click Share Button');
        }}>SHARE</div>)}
        <Lines />
        <div id="bracket">
          <div className="bracket_names_column_left">
            <div className="bracket_name_container"><div className="bracket_name">{gameData[1].name}</div></div>
            <div className="bracket_name_container"><div className="bracket_name">{gameData[2].name}</div></div>
            <div className="bracket_name_container"><div className="bracket_name">{gameData[3].name}</div></div>
            <div className="bracket_name_container"><div className="bracket_name">{gameData[4].name}</div></div>
            <div className="bracket_name_container"><div className="bracket_name">{gameData[5].name}</div></div>
            <div className="bracket_name_container"><div className="bracket_name">{gameData[6].name}</div></div>
            <div className="bracket_name_container"><div className="bracket_name">{gameData[7].name}</div></div>
            <div className="bracket_name_container"><div className="bracket_name">{gameData[8].name}</div></div>
          </div>
          <div className="column one">
            <div className="match">
              <Square handleSquareClick={handleSquareClick} position={1} next={9} rapper={gameData[1]} handleClassHighlight={handleClassHighlight} />
              <Square handleSquareClick={handleSquareClick} position={2} next={9} rapper={gameData[2]} handleClassHighlight={handleClassHighlight} />
            </div>
            <div className="match">
              <Square handleSquareClick={handleSquareClick} position={3} next={10} rapper={gameData[3]} handleClassHighlight={handleClassHighlight} />
              <Square handleSquareClick={handleSquareClick} position={4} next={10} rapper={gameData[4]} handleClassHighlight={handleClassHighlight} />
            </div>
            <div className="match">
              <Square handleSquareClick={handleSquareClick} position={5} next={11} rapper={gameData[5]} handleClassHighlight={handleClassHighlight} />
              <Square handleSquareClick={handleSquareClick} position={6} next={11} rapper={gameData[6]} handleClassHighlight={handleClassHighlight} />
            </div>
            <div className="match">
              <Square handleSquareClick={handleSquareClick} position={7} next={12} rapper={gameData[7]} handleClassHighlight={handleClassHighlight} />
              <Square handleSquareClick={handleSquareClick} position={8} next={12} rapper={gameData[8]} handleClassHighlight={handleClassHighlight} />
            </div>
          </div>

          <div className="column two">
            <div className="match">
              <Square handleSquareClick={handleSquareClick} position={9} next={13} origin={[1, 2]} rapper={gameData[9]} handleClassHighlight={handleClassHighlight} />
              <Square handleSquareClick={handleSquareClick} position={10} next={13} origin={[3, 4]} rapper={gameData[10]} handleClassHighlight={handleClassHighlight} />
            </div>
            <div className="match">
              <Square handleSquareClick={handleSquareClick} position={11} next={14} origin={[5, 6]} rapper={gameData[11]} handleClassHighlight={handleClassHighlight} />
              <Square handleSquareClick={handleSquareClick} position={12} next={14} origin={[7, 8]} rapper={gameData[12]} handleClassHighlight={handleClassHighlight} />
            </div>
          </div>

          <div className="column three">
            <div className="match">
              <Square handleSquareClick={handleSquareClick} position={13} next={15} origin={[9, 10]} rapper={gameData[13]} handleClassHighlight={handleClassHighlight} />
              <Square handleSquareClick={handleSquareClick} position={14} next={15} origin={[11, 12]} rapper={gameData[14]} handleClassHighlight={handleClassHighlight} />
            </div>
          </div>

          <div className="column four">
            <div className="match">
              <Square handleSquareClick={handleSquareClick} position={15} next={"center"} origin={[13, 14]} rapper={gameData[15]} handleClassHighlight={handleClassHighlight} />
            </div>
          </div>

          <div className="column five">
            <Round round={currentRound}/>
            {dropCrown()}
            <div className="match">
              <Square
                handleSquareClick={handleSquareClick}
                origin={[15, 16]}
                position={31}
                rapper={gameData[31]}
                type={"center"}
                handleClassHighlight={handleClassHighlight} />
            </div>
          </div>

          <div className="column six">
            <div className="match">
              <Square handleSquareClick={handleSquareClick} position={16} next={"center"} origin={[17, 18]} rapper={gameData[16]} handleClassHighlight={handleClassHighlight} />
            </div>
          </div>

          <div className="column seven">
            <div className="match">
              <Square handleSquareClick={handleSquareClick} position={17} next={16} origin={[19, 20]} rapper={gameData[17]} handleClassHighlight={handleClassHighlight} />
              <Square handleSquareClick={handleSquareClick} position={18} next={16} origin={[21, 22]} rapper={gameData[18]} handleClassHighlight={handleClassHighlight} />
            </div>
          </div>

          <div className="column eight">
            <div className="match">
              <Square handleSquareClick={handleSquareClick} position={19} next={17} origin={[23, 24]} rapper={gameData[19]} handleClassHighlight={handleClassHighlight} />
              <Square handleSquareClick={handleSquareClick} position={20} next={17} origin={[25, 26]} rapper={gameData[20]} handleClassHighlight={handleClassHighlight} />
            </div>
            <div className="match">
              <Square handleSquareClick={handleSquareClick} position={21} next={18} origin={[27, 28]} rapper={gameData[21]} handleClassHighlight={handleClassHighlight} />
              <Square handleSquareClick={handleSquareClick} position={22} next={18} origin={[29, 30]} rapper={gameData[22]} handleClassHighlight={handleClassHighlight} />
            </div>
          </div>

          <div className="column nine">
            <div className="match">
              <Square handleSquareClick={handleSquareClick} position={23} next={19} rapper={gameData[23]} handleClassHighlight={handleClassHighlight} />
              <Square handleSquareClick={handleSquareClick} position={24} next={19} rapper={gameData[24]} handleClassHighlight={handleClassHighlight} />
            </div>
            <div className="match">
              <Square handleSquareClick={handleSquareClick} position={25} next={20} rapper={gameData[25]} handleClassHighlight={handleClassHighlight} />
              <Square handleSquareClick={handleSquareClick} position={26} next={20} rapper={gameData[26]} handleClassHighlight={handleClassHighlight} />
            </div>
            <div className="match">
              <Square handleSquareClick={handleSquareClick} position={27} next={21} rapper={gameData[27]} handleClassHighlight={handleClassHighlight} />
              <Square handleSquareClick={handleSquareClick} position={28} next={21} rapper={gameData[28]} handleClassHighlight={handleClassHighlight} />
            </div>
            <div className="match">
              <Square handleSquareClick={handleSquareClick} position={29} next={22} rapper={gameData[29]} handleClassHighlight={handleClassHighlight} />
              <Square handleSquareClick={handleSquareClick} position={30} next={22} rapper={gameData[30]} handleClassHighlight={handleClassHighlight} />
            </div>
          </div>
          <div className="bracket_names_column_right">
            <div className="bracket_name_container"><div className="bracket_name">{gameData[23].name}</div></div>
            <div className="bracket_name_container"><div className="bracket_name">{gameData[24].name}</div></div>
            <div className="bracket_name_container"><div className="bracket_name">{gameData[25].name}</div></div>
            <div className="bracket_name_container"><div className="bracket_name">{gameData[26].name}</div></div>
            <div className="bracket_name_container"><div className="bracket_name">{gameData[27].name}</div></div>
            <div className="bracket_name_container"><div className="bracket_name">{gameData[28].name}</div></div>
            <div className="bracket_name_container"><div className="bracket_name">{gameData[29].name}</div></div>
            <div className="bracket_name_container"><div className="bracket_name">{gameData[30].name}</div></div>
          </div>
        </div>
      </div>
      <Notification notificationStatus={notificationStatus} />
    </React.Fragment>
  );
}
export default Bracket;
